import { UserMissionLevelForm } from './UserMissionLevelForm'
import { withUserMissionLevelForm } from './withUserMissionLevelForm'

const ConnectedUserMissionLevelForm =
  withUserMissionLevelForm(UserMissionLevelForm)

export { ConnectedUserMissionLevelForm as UserMissionLevelForm }
